import { z } from "zod/v4"
import { CreatedAt, UpdatedAt } from "./system"
import { UserId } from "../id"
import { DocumentSnapshotLike } from "../firestore"

export const UserSettingDocumentMeta = z.object({
  accept_push: z.boolean().optional(),
  accept_call: z.boolean().optional(),
  accept_super_call: z.boolean().optional(),
})

export const UserSettingDocumentBody = z.intersection(
  UserSettingDocumentMeta,
  z.object({
    created_at: CreatedAt,
    updated_at: UpdatedAt,
  })
)

export type UserSettingDocument = UserSettingDocumentBody & {
  id: UserId,
}

export type UserSettingDocumentBody = z.infer<typeof UserSettingDocumentBody>

export class UserSettingDocuments {
  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): UserSettingDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: UserId(doc.id),
      accept_push: data["accept_push"],
      accept_call: data["accept_call"],
      accept_super_call: data["accept_super_call"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }

  static toDocument(setting: UserSettingDocumentBody): object {
    const doc: Record<string, unknown> = {
      created_at: setting.created_at,
      updated_at: setting.updated_at,
    }
    if (setting.accept_push !== undefined) {
      doc.accept_push = setting.accept_push
    }
    if (setting.accept_call !== undefined) {
      doc.accept_call = setting.accept_call
    }
    if (setting.accept_super_call !== undefined) {
      doc.accept_super_call = setting.accept_super_call
    }
    return doc
  }
}
